var _circle, _path, _path2, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnchorIconWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.14062,
    cy: 3.09375,
    r: 2.25,
    stroke: "#fff",
    strokeWidth: 1.6875
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 11.1094V12.375C3.42188 13.5938 5.54062 16.0312 9.14062 16.0312",
    stroke: "#fff",
    strokeWidth: 1.6875,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4688 11.1094V12.375C14.8594 13.5938 12.7406 16.0312 9.14062 16.0312",
    stroke: "#fff",
    strokeWidth: 1.6875,
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.14062,
    y1: 6.1875,
    x2: 9.14062,
    y2: 17.1562,
    stroke: "#fff",
    strokeWidth: 1.6875,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.3906,
    y1: 9,
    x2: 6.89062,
    y2: 9,
    stroke: "#fff",
    strokeWidth: 1.6875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchorIconWhite);
export default __webpack_public_path__ + "static/media/anchor-icon-white.b134e03071b12fe71dec83aee8da4563.svg";
export { ForwardRef as ReactComponent };